var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItemsB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.9 11.26A7.2 7.2 0 0 1 13.05 4h21.9a7.2 7.2 0 0 1 7.16 7.26c0 4-3.2 7.25-7.16 7.25h-21.9a7.2 7.2 0 0 1-7.15-7.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "m5 15.8.4.97a7.16 7.16 0 0 0 6.6 4.46h7.53v.91c0 2.5 2 4.53 4.47 4.53a4.5 4.5 0 0 0 4.47-4.53v-.9H36c2.9 0 5.5-1.77 6.6-4.47l.41-.98v19.95A7.2 7.2 0 0 1 35.85 43H12.16A7.2 7.2 0 0 1 5 35.74V15.8Zm13.84 14.47c0-1 .8-1.8 1.8-1.8h6.73a1.81 1.81 0 0 1-.01 3.62H25.8v3.63h3c.99 0 1.79.8 1.79 1.81 0 1-.8 1.81-1.8 1.81h-9.57a1.8 1.8 0 0 1-1.79-1.8c0-1.01.8-1.82 1.79-1.82h3v-3.63h-1.58a1.8 1.8 0 0 1-1.79-1.82Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.21 21.23v.91c0 1 .8 1.81 1.79 1.81a1.8 1.8 0 0 0 1.79-1.81v-.9h-3.58Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItemsB);
export default __webpack_public_path__ + "static/media/items_b.03b56aac00f733ab4433571d55acb342.svg";
export { ForwardRef as ReactComponent };